import Avatar from '../Common/Avatar/Avatar';
import { MdOutlineKeyboardArrowDown } from '../CustomSVG/MaterialIcons';

const AvatarButton = ({ userName, imagePath, height, width }) => {
  return (
    <div className='flex items-center justify-center text-[16px] text-black'>
      <Avatar
        height={height}
        width={width}
        userName={userName}
        imagePath={imagePath}
      />
      <div className='ml-[8px] hidden max-w-[200px] truncate text-[16px]   xl:block'>
        {userName !== undefined ? userName : 'Loading...'}
      </div>
      <MdOutlineKeyboardArrowDown className='m-2 hidden h-[16px] w-[16px] text-[#323232] md:block' />
    </div>
  );
};

export default AvatarButton;
